export default "__VITE_ASSET__bbda0725__"